<template>
<div>
    <notifications group="cart" position="bottom right" />
    <navigation></navigation>
    <transition enter-active-class="animated fadeIn animation-delay-100" leave-active-class="animated fadeOut animation-delay-100">
    <router-view :key="$route.fullPath"/>
    </transition>
    <mhdfooter></mhdfooter>
</div>
</template>
<script>
//navbar and footer
import navbar from './components/navbar';
import navigation from './components/navigation';
import mhdfooter from './components/mhdfooter';
import 'vue2-animate/dist/vue2-animate.min.css';

export default {
  name: 'App',
  components: {
    navigation,
    mhdfooter
  },
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  }
};
</script>

<style>
/*@import './assets/css/vendor.min.css';
@import './assets/css/styles.min.css';
@import 'vue2-animate/dist/vue2-animate.min.css';
*/
.animation-delay-100 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.animation-delay-200 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue